import React from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import _ from 'lodash';

import QuestionsWritten from '../questions-written';

import {
  Container,
  ContainerQuestions,
  ContainerEmptyTask,
  Header,
} from './styles';
import VerticalChart from '../../../../../../../../core/analytics/vertical-chart-survey-and-unmoderated';

const QUESTION_TYPE_RANGE = 'range';
const QUESTION_TYPE_WRITTEN = 'written';
const QUESTION_TYPE_SINGLE = 'single_select';
const QUESTION_TYPE_MULTIPLE = 'multiple_select';

const PostTaskQuestions = (props) => {
  const {
    selectedTask,
    projectTestType,
  } = props;

  const {
    tasks,
  } = selectedTask;

  if (_.isEmpty(tasks)) {
    return (
      <Container>
        <Header as="h1">Post task questions</Header>
        <ContainerEmptyTask>
          You didn’t ask any post task questions
        </ContainerEmptyTask>
      </Container>
    );
  }

  const getComponent = (task, type) => {
    switch (type) {
      case QUESTION_TYPE_RANGE:
        return (
          <VerticalChart
            questionType={type}
            title="Rating Scale"
            color="#93dfff"
            data={task}
            projectTestType={projectTestType}
          />
        );
      case QUESTION_TYPE_WRITTEN:
        return <QuestionsWritten key={task.id} data={task} />;

      case QUESTION_TYPE_MULTIPLE:
        return (
          <VerticalChart
            questionType={type}
            title="Multiple Selection"
            color="#A8BEF9"
            data={task}
            projectTestType={projectTestType}
          />
        );

      case QUESTION_TYPE_SINGLE:
        return (
          <VerticalChart
            questionType={type}
            title="Single Selection"
            color="#82EBD4"
            data={task}
            projectTestType={projectTestType}
          />
        );

      default:
        return (
          <ContainerEmptyTask key={v4()}>
            Unknow question type
          </ContainerEmptyTask>
        );
    }
  };

  return (
    <Container>
      <Header>Post task questions</Header>

      <ContainerQuestions>
        {tasks.map((task) => (
          getComponent(task, task.questionType)
        ))}
      </ContainerQuestions>

    </Container>
  );
};

PostTaskQuestions.propTypes = {
  selectedTask: PropTypes.shape({
    taskTitle: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    id: PropTypes.string,
    tasks: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  projectTestType: PropTypes.string.isRequired,
};

export default PostTaskQuestions;
